export enum CarnivalStandType {
  FortuneBasket = 'FortuneBasket',
  ShootingRange = 'ShootingRange',
}

export enum CarnivalStandMainComponent {
  FortuneBasket = 'FortuneBasketMain',
  ShootingRange = 'ShootingRangeMain',
}
